import React, { useState, useEffect } from "react";
import { useParams } from 'react-router-dom';
import "./ResetPasswordUsingResetLink.scss";
import logo from "../../assets/images/ZR.png";
import { useForm } from 'react-hook-form';
import masterApi from "../../services/masterApi";
import { useNavigate } from "react-router-dom";
const ResetPasswordUsingResetLink = () => {
  const { register, handleSubmit, getValues, formState: { errors } } = useForm()
  const { token } = useParams();
  const navigate = useNavigate();
  const [isValidLink, setIsValidLink] = useState(false);
  const onSubmit = async (data) => {
    const formData = {
      ...data,  // Password fields
      token     // Add the token to the form data
    };
    const response = await masterApi.resetPasswordWithLink({ formData });
    if (response?.data?.ok) {
      navigate('../')
    } else {
    }
  }
  const onReset = () => {
    navigate('../')
  }
  const fetchData = async () => {
    try {
      const formData = { token };
      const response = await masterApi.validateResetPasswordLink(formData);
      if (response?.data?.ok) {
        setIsValidLink(true);
      } else {
      }
    } catch (error) {
      console.error("Error validating token:", error);
    }
  };

  useEffect(() => {
    fetchData(); // Call the function to validate the link
  }, [token]); // Include token as a dependency

  return (
    <div className="main-login-area">
      <div className="auth-one-bg-position auth-one-bg" id="auth-particles">
        <div className="bg-overlay"></div>
        <div className="shape">
          <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 1440 120">
            <path d="M 0,36 C 144,53.6 432,123.2 720,124 C 1008,124.8 1296,56.8 1440,40L1440 140L0 140z"></path>
          </svg>

        </div>
      </div>
      <div className="auth-page-content d-flex">
        <div className="container pt-5">
          <div className="justify-content-center row h-100 d-flex align-content-center pt-3">
            <div className="col-md-8 col-lg-5 col-xl-4 height-cls">
              <div className="card">
                <div className="p-4 card-body">
                  <div className="login-box">
                    <div className="login-content-area">
                    <div className="logo-area">
                      <div className="logo-box  d-flex flex-column justify-content-center align-items-center ">
                      <div className="logo-img text-center mb-4">
                            <img src={logo} alt="Logo" />
                          </div>
                          <h5 className="text-center mb-1">
                          {isValidLink ? "CREATE NEW PASSWORD" : "Invalid Reset Link"}

                          </h5>
                        </div>
                      </div>
                      <div className="login-input-area">
                       
                        {isValidLink ? (
                          <form className="login-form space-between" onSubmit={handleSubmit(onSubmit)}>

                            <div className="row">
                              <div className="col-12 col-md-12 mb-4 position-relative">
                                <label className="form-label" >
                                  New Password <span className="asterisk danger">*</span>
                                </label>
                                <input
                                  {...register("newpassword", {
                                    required: "New Password is required",
                                    pattern: {
                                      value: new RegExp(process.env.REACT_APP_PASSWORD_REGEX),
                                      message:
                                        "Password must be at least 8 characters long, contain at least one uppercase letter, one lowercase letter, one number, and one special character (!@#$&*)",
                                    },
                                  })}
                                  className={`input ${errors.newpassword ? "form-control required" : "form-control"}`}
                                  type="password"
                                  placeholder="New Password"
                                />
                                {errors.newpassword && (
                                  <div className="danger space-between">
                                    {errors.newpassword.message}
                                  </div>
                                )}
                              </div>
                              <div className="col-12 col-md-12 mb-4 position-relative">
                                <label className="form-label" >
                                  Confirm Password <span className="asterisk danger">*</span>
                                </label>
                                <input
                                  {...register("confirmpassword", {
                                    required: "Confirm Password is required",
                                    validate: (value) =>
                                      value === getValues("newpassword") || "Passwords do not match",
                                  })}
                                  className={`input ${errors.confirmpassword ? "form-control required" : "form-control"}`}
                                  type="password"
                                  placeholder="Confirm Password"
                                />
                                {errors.confirmpassword && (
                                  <div className="danger space-between">
                                    {errors.confirmpassword.message}
                                  </div>
                                )}
                              </div>
                            </div>
                            <div className="d-flex align-items-center gap-3">
                            <button
                                className="btn btn-dark"
                                onClick={(e) => {
                                  e.preventDefault();
                                  onReset();
                                }}
                              >
                                Cancel
                              </button>
                              <button className="btn btn-primary" type="submit">
                                Submit
                              </button>
                            </div>

                           
                          </form>


                        ) : <p className="mb-0 danger">The link is invalid or has expired. Please request a new password reset link.</p>}
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

  );
};

export default ResetPasswordUsingResetLink;

